function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_45",
  "data-name": "Trazado 45",
  d: "M10.283,152.209a1.559,1.559,0,1,0-2.832,0,7.9,7.9,0,0,0-6.394,7.213H0v1.039H1.238l1.039,2.078H15.423l1.039-2.078h1.272v-1.039H16.643a7.871,7.871,0,0,0-6.36-7.213Zm-1.936-.65a.52.52,0,1,1,.52.52A.52.52,0,0,1,8.348,151.559Zm.52,1.559a6.792,6.792,0,0,1,6.735,6.3H2.1A6.812,6.812,0,0,1,8.867,153.117Zm5.914,8.382H2.919L2.4,160.46H15.3Z",
  transform: "translate(0 -144.804)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_46",
  "data-name": "Trazado 46",
  d: "M302.559,1.039h4.676V0h-4.676a1.559,1.559,0,1,0,0,3.117h2.078a.52.52,0,0,1,0,1.039H303.6a1.56,1.56,0,0,0-1.559,1.559v.52h1.039v-.52a.52.52,0,0,1,.52-.52h1.039a1.559,1.559,0,0,0,0-3.117h-2.078a.52.52,0,1,1,0-1.039Z",
  transform: "translate(-290.574)",
  fill: "#fff"
});

function SvgSalver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "salver",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.734,
    height: 17.734,
    viewBox: "0 0 17.734 17.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalver);
export default __webpack_public_path__ + "static/media/salver.e9969876.svg";
export { ForwardRef as ReactComponent };